import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoveUpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"move_up"}/>
}
